import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogoacabs() {



    const cardData = {




keyword: "Mumbai to Goa Cabs",

headingDescription: "Shreesha Tours & Travels provides premium Mumbai to Goa cab services for tourists, families, couples, corporate travelers, and groups looking for a safe and comfortable road trip. We offer one-way cabs, round-trip taxi services, multi-day tour packages, and customized travel solutions with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement and budget. With doorstep pickup anywhere in Mumbai, flexible departure schedules, transparent pricing, easy online booking, and 24/7 customer support, we ensure a smooth and enjoyable journey. Whether you are planning a beach vacation, honeymoon, family holiday, bachelor trip, corporate outing, or festive getaway, Shreesha Tours & Travels offers reliable Mumbai to Goa cab services with clean vehicles, professional drivers, and excellent customer service. Enjoy scenic highway drives through the Western Ghats while traveling comfortably to Goa's famous beaches, churches, forts, waterfalls, and nightlife destinations.",

topPlaces: [
  {
    title: "Calangute Beach",
    description: "Calangute Beach is one of Goa's largest and most popular beaches, famous for its golden shoreline, water sports, beach shacks, shopping stalls, and vibrant atmosphere. It is an ideal destination for families, couples, and adventure lovers looking to enjoy the true spirit of Goa."
  },
  {
    title: "Baga Beach",
    description: "Baga Beach is a lively tourist hotspot known for exciting nightlife, beach clubs, seafood restaurants, water sports, and beautiful sunset views. Visitors can enjoy parasailing, jet skiing, banana boat rides, and a wide variety of entertainment activities."
  },
  {
    title: "Dudhsagar Waterfalls",
    description: "Dudhsagar Waterfalls is one of India's tallest and most spectacular waterfalls, surrounded by dense forests and the Western Ghats. The breathtaking scenery, jeep safari, and trekking opportunities make it one of the most visited attractions during a Goa trip."
  },
  {
    title: "Fort Aguada",
    description: "Fort Aguada is a historic Portuguese fort overlooking the Arabian Sea. It is famous for its lighthouse, panoramic coastal views, rich history, and stunning sunset points, making it a must-visit destination for history lovers and photographers."
  },
  {
    title: "Basilica of Bom Jesus",
    description: "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of Goa's most iconic churches. Renowned for its beautiful Baroque architecture and the sacred remains of St. Francis Xavier, it attracts visitors from around the world."
  },
  {
    title: "Candolim Beach",
    description: "Candolim Beach is known for its peaceful atmosphere, clean shoreline, luxury resorts, and beachside restaurants. It is perfect for travelers seeking a relaxing holiday away from crowded tourist spots while still enjoying Goa's coastal beauty."
  },
  {
    title: "Anjuna Beach",
    description: "Anjuna Beach is famous for its vibrant flea market, beach parties, dramatic rocky coastline, and lively cafés. It is a favorite destination for backpackers, couples, and visitors looking for Goa's unique cultural and nightlife experiences."
  },
  {
    title: "Vagator Beach",
    description: "Vagator Beach offers stunning cliffs, clear blue waters, beach cafés, and unforgettable sunset views. It is one of North Goa's most scenic beaches and is popular among photographers, couples, and music festival enthusiasts."
  },
  {
    title: "Palolem Beach",
    description: "Palolem Beach in South Goa is known for its crescent-shaped shoreline, calm waters, colorful beach huts, kayaking, dolphin trips, and peaceful surroundings. It is an excellent destination for families and honeymoon couples seeking a relaxing vacation."
  },
  {
    title: "Colva Beach",
    description: "Colva Beach is one of South Goa's most beautiful beaches, offering soft white sand, swaying coconut trees, water sports, local seafood restaurants, and a tranquil atmosphere. It is a perfect destination for leisure travelers looking to unwind by the sea."
  }
],




"services": [
  {
    "name": "Mumbai to Goa Cab",
    "description": "Book Mumbai to Goa Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, and SUV cabs for family vacations, business trips, beach holidays, and one way or round trip journeys."
  },
  {
    "name": "Mumbai to Goa Car Rental",
    "description": "Hire Mumbai to Goa Car Rental with chauffeur-driven vehicles for convenient long-distance travel. Enjoy comfortable seating, experienced drivers, and flexible travel schedules."
  },
  {
    "name": "Mumbai to Goa Taxi Fare",
    "description": "Check Mumbai to Goa Taxi Fare with transparent pricing, affordable packages, and no hidden charges. Travel comfortably with premium outstation cab services."
  },
  {
    "name": "Mumbai to Goa Taxi",
    "description": "Choose Mumbai to Goa Taxi for reliable intercity transportation with professional drivers, clean AC vehicles, and flexible one way and round trip booking options."
  },
  {
    "name": "Mumbai to Goa Cab Fare",
    "description": "Get the best Mumbai to Goa Cab Fare with competitive pricing and quality chauffeur-driven services for comfortable outstation journeys."
  },
  {
    "name": "Mumbai to Goa Taxi One Way Fare",
    "description": "Book Mumbai to Goa Taxi One Way Fare with economical pricing, fixed rates, and hassle-free travel without return charges."
  },
  {
    "name": "Mumbai to Goa Cab Price",
    "description": "Check Mumbai to Goa Cab Price for affordable travel packages with Sedan, Ertiga, Innova Crysta, and SUV vehicle options."
  },
  {
    "name": "Mumbai to Goa by Car Fare",
    "description": "Get Mumbai to Goa by Car Fare with transparent pricing and comfortable chauffeur-driven vehicles for family and business travel."
  },
  {
    "name": "Book Cab from Mumbai to Goa",
    "description": "Book Cab from Mumbai to Goa online with instant confirmation, multiple vehicle choices, and professional drivers for a smooth journey."
  },
  {
    "name": "Car Hire from Mumbai to Goa",
    "description": "Hire Car from Mumbai to Goa for premium chauffeur-driven travel with clean vehicles, experienced drivers, and flexible pickup options."
  },
  {
    "name": "Car on Rent from Mumbai to Goa",
    "description": "Reserve Car on Rent from Mumbai to Goa with affordable rental packages, comfortable seating, and reliable outstation transportation."
  },
  {
    "name": "Mumbai Goa Cab Service",
    "description": "Choose Mumbai Goa Cab Service for safe interstate travel with professional chauffeurs, spacious vehicles, and affordable one way and round trip packages."
  },
  {
    "name": "Mumbai to Goa by Road Taxi Fare",
    "description": "Check Mumbai to Goa by Road Taxi Fare with competitive pricing, experienced drivers, and premium vehicle options for comfortable travel."
  },
  {
    "name": "Mumbai to Goa Cab Booking",
    "description": "Complete Mumbai to Goa Cab Booking online with easy reservations, instant confirmation, and flexible travel schedules."
  },
  {
    "name": "Mumbai to Goa Cab Booking Price",
    "description": "Get Mumbai to Goa Cab Booking Price with transparent fares, affordable packages, and multiple vehicle categories for every budget."
  },
  {
    "name": "Mumbai to Goa Cab Charges",
    "description": "Check Mumbai to Goa Cab Charges with clear pricing, quality service, and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Goa Cab Hire",
    "description": "Book Mumbai to Goa Cab Hire for reliable long-distance travel with professional chauffeurs and well-maintained AC vehicles."
  },
  {
    "name": "Mumbai to Goa Cab Rates",
    "description": "Compare Mumbai to Goa Cab Rates and choose affordable travel packages with comfortable vehicles and experienced drivers."
  },
  {
    "name": "Mumbai to Goa Cab Service",
    "description": "Hire Mumbai to Goa Cab Service for dependable outstation transportation with clean vehicles, professional drivers, and flexible booking options."
  },
  {
    "name": "Mumbai to Goa Cab Service Fare",
    "description": "Check Mumbai to Goa Cab Service Fare with transparent pricing and affordable one way or round trip travel packages."
  },
  {
    "name": "Mumbai to Goa Car Booking",
    "description": "Reserve Mumbai to Goa Car Booking with instant confirmation, premium vehicles, and experienced chauffeurs for comfortable travel."
  },
  {
    "name": "Mumbai to Goa Car Hire",
    "description": "Choose Mumbai to Goa Car Hire for chauffeur-driven travel with spacious vehicles suitable for family holidays and business trips."
  },
  {
    "name": "Mumbai to Goa Car Rental with Driver",
    "description": "Book Mumbai to Goa Car Rental with Driver for stress-free travel with skilled chauffeurs, comfortable AC vehicles, and reliable service."
  },
  {
    "name": "Mumbai to Goa Car Service",
    "description": "Hire Mumbai to Goa Car Service for smooth interstate travel with premium cars, affordable fares, and professional drivers."
  },
  {
    "name": "Mumbai to Goa Ola Cabs Fare",
    "description": "Check Mumbai to Goa Ola Cabs Fare alternatives with affordable private cab services offering comfortable vehicles and transparent pricing."
  },
  {
    "name": "Mumbai to Goa One Way Cab",
    "description": "Book Mumbai to Goa One Way Cab for economical single-trip travel with fixed pricing, comfortable vehicles, and professional chauffeurs."
  },
  {
    "name": "Mumbai to Goa One Way Taxi",
    "description": "Choose Mumbai to Goa One Way Taxi for budget-friendly travel with reliable drivers, flexible pickup options, and no return charges."
  },
  {
    "name": "Mumbai to Goa Taxi Price",
    "description": "Get Mumbai to Goa Taxi Price with affordable packages, quality vehicles, and experienced chauffeurs for a safe journey."
  },
  {
    "name": "Mumbai to Goa Taxi Rate",
    "description": "Check Mumbai to Goa Taxi Rate with competitive pricing and premium chauffeur-driven vehicles for convenient outstation travel."
  },
  {
    "name": "Mumbai to Goa Taxi Service",
    "description": "Book Mumbai to Goa Taxi Service for reliable interstate travel with clean AC cars, trained drivers, and comfortable travel experiences."
  },
  {
    "name": "Taxi Service from Mumbai to Goa",
    "description": "Hire Taxi Service from Mumbai to Goa for safe and hassle-free travel with multiple vehicle options, affordable fares, and professional chauffeurs."
  },
  {
    "name": "Mumbai Airport to Goa Cab",
    "description": "Reserve Mumbai Airport to Goa Cab with direct airport pickup, experienced drivers, comfortable vehicles, and reliable long-distance transportation."
  },
  {
    "name": "Mumbai to Goa One Way Cab",
    "description": "Choose Mumbai to Goa One Way Cab for affordable point-to-point travel with professional drivers, clean vehicles, and instant booking confirmation."
  }
],
"tableData": [
  ["Mumbai to Goa Cab", "Mumbai to Goa Car Rental"],
  ["Mumbai to Goa Taxi Fare", "Mumbai to Goa Taxi"],
  ["Mumbai to Goa Cab Fare", "Mumbai to Goa Taxi One Way Fare"],
  ["Mumbai to Goa Cab Price", "Mumbai to Goa by Car Fare"],
  ["Book Cab from Mumbai to Goa", "Car Hire from Mumbai to Goa"],
  ["Car on Rent from Mumbai to Goa", "Mumbai Goa Cab Service"],
  ["Mumbai to Goa by Road Taxi Fare", "Mumbai to Goa Cab Booking"],
  ["Mumbai to Goa Cab Booking Price", "Mumbai to Goa Cab Charges"],
  ["Mumbai to Goa Cab Hire", "Mumbai to Goa Cab Rates"],
  ["Mumbai to Goa Cab Service", "Mumbai to Goa Cab Service Fare"],
  ["Mumbai to Goa Car Booking", "Mumbai to Goa Car Hire"],
  ["Mumbai to Goa Car Rental with Driver", "Mumbai to Goa Car Service"],
  ["Mumbai to Goa Ola Cabs Fare", "Mumbai to Goa One Way Cab"],
  ["Mumbai to Goa One Way Taxi", "Mumbai to Goa Taxi Price"],
  ["Mumbai to Goa Taxi Rate", "Mumbai to Goa Taxi Service"],
  ["Taxi Service from Mumbai to Goa", "Mumbai Airport to Goa Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Goa Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers comfortable Mumbai to Goa cab services with well-maintained vehicles, experienced drivers, and flexible travel options for a memorable road trip."
  },
  {
    WhyChooseheading: "Perfect for Beach Holidays & Family Trips",
    WhyChoosedescription: "Whether you're planning a Goa vacation, honeymoon, weekend getaway, family holiday, corporate outing, or friends' trip, our private cabs ensure a relaxing and enjoyable journey."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your travel group and luggage requirements."
  },
  {
    WhyChooseheading: "One Way, Round Trip & Multi-Day Travel",
    WhyChoosedescription: "Book a one-way cab to Goa, a round-trip package, or a customized multi-day travel plan with flexible pickup and return schedules."
  },
  {
    WhyChooseheading: "Professional Drivers for Highway Routes",
    WhyChoosedescription: "Our experienced chauffeurs are familiar with the Mumbai-Goa highway and ensure a safe, smooth, and comfortable journey throughout your trip."
  },
  {
    WhyChooseheading: "Customized Goa Sightseeing Option",
    WhyChoosedescription: "Extend your journey with customized sightseeing to North Goa, South Goa, beaches, forts, churches, waterfalls, and other popular tourist attractions."
  },
  {
    WhyChooseheading: "Comfortable Long-Distance Travel Experience",
    WhyChoosedescription: "Travel in clean, spacious, and regularly serviced vehicles designed to provide maximum comfort during long-distance journeys."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Enjoy quick booking assistance, transparent pricing, and dedicated customer support for your Mumbai to Goa cab reservation."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Goa Cabs?",
    answer: "Yes, we provide Mumbai to Goa cab services for one-way, round-trip, holiday, and customized travel requirements."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Goa?",
    answer: "Yes, one-way taxi services are available for direct travel from Mumbai to Goa."
  },
  {
    question: "Which vehicles are available for Mumbai to Goa travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is the cab suitable for family vacations?",
    answer: "Yes, our spacious and comfortable vehicles are ideal for families, couples, friends, and corporate groups travelling to Goa."
  },
  {
    question: "Can I book a round-trip Mumbai to Goa taxi?",
    answer: "Yes, we offer flexible round-trip cab packages with return dates based on your travel plans."
  },
  {
    question: "Can Goa sightseeing be included in the package?",
    answer: "Yes, sightseeing across North Goa, South Goa, beaches, churches, forts, and other attractions can be added to your itinerary."
  },
  {
    question: "Do you provide pickup from Mumbai Airport and hotels?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and other preferred locations."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, state permits, and other applicable charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Mumbai to Goa cab service available throughout the week?",
    answer: "Yes, Shreesha Tours & Travels provides cab booking services seven days a week, subject to vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Goa Cab?",
    answer: "Share your pickup location, travel date, destination, passenger details, and preferred vehicle to receive your fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Sharma",
    feedback: "Our Mumbai to Goa trip with Shreesha Tours & Travels was fantastic. The Innova Crysta was clean, the driver was experienced, and the long journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "We booked a cab for our Goa family vacation and received excellent service. The vehicle was spacious, pickup was on time, and the entire journey was smooth and enjoyable.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-goa-cabs.webp",
  "description":
    "Book Mumbai to Goa Cabs with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Goa with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for beach holidays, family vacations, business travel, airport transfers, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-goa-cabs"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai to Goa Cabs | Coastal Road Trip Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Goa Cabs with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Goa with 24x7 online cab booking and transparent taxi fares."
  />

  <meta
    name="keywords"
    content="Mumbai to Goa Cabs, Mumbai to Goa Cab, Mumbai to Goa Car Rental, Mumbai to Goa Taxi Fare, Mumbai to Goa Taxi, Mumbai to Goa Cab Fare, Mumbai to Goa Taxi One Way Fare, Mumbai to Goa Cab Price, Mumbai to Goa By Car Fare, Book Cab From Mumbai to Goa, Car Hire From Mumbai to Goa, Car On Rent From Mumbai to Goa, Mumbai Goa Cab Service, Mumbai to Goa One Way Cab, Mumbai to Goa Round Trip Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitogoacabs;